import { GetPlayerWithLuckyWheelReceiveData } from '@/modules/manage-player/type'
import { columns } from '../PlayerWithLuckyWheelReceiveTable/constants'
import { DataTableArrow } from '@/common/ui/table/data-table-arrow'
import { Card } from '@/common/ui/card'
import { Separator } from '@/common/ui/separator'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'
import { Button } from '@/common/ui/button'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import PlayerSearchControls from '@/common/components/PlayerSearchControls'

interface PlayerWithLuckyWheelReceiveListingProps {
	data: GetPlayerWithLuckyWheelReceiveData[]
	total: number
	isLoading?: boolean
	showBackButton?: boolean
	onSort?: (columnId: string, order: 'asc' | 'desc' | undefined) => void
}

export default function PlayerWithLuckyWheelReceiveListing({
	data,
	total,
	isLoading,
	onSort,
	showBackButton = true,
}: PlayerWithLuckyWheelReceiveListingProps) {
	const navigate = useNavigate()

	return (
		<Card>
			<div className="space-y-4 p-3 sm:p-4">
				{showBackButton && (
					<Button
						onClick={() => navigate(-1)}
						variant="outline"
						size="sm"
						className="mb-4 flex items-center gap-2"
					>
						<ArrowLeft className="h-4 w-4" />
						ย้อนกลับ
					</Button>
				)}

				{/* Header Section - Mobile Responsive */}
				<div className="space-y-4">
					{/* Title and Date Controls Row */}
					<div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
						{/* Title */}
						<div>
							<h2 className="text-xl font-bold tracking-tight sm:text-2xl">
								ผู้เล่นที่มีการหมุนกงล้อ
							</h2>
							<p className="text-sm text-muted-foreground sm:text-base">
								รายการผู้เล่นที่มีการหมุนกงล้อ {total}
							</p>
						</div>

						{/* Date Controls */}
						<div className="flex flex-col gap-3 sm:items-end">
							<DateRangePicker />
							<DateRangeButtons />
						</div>
					</div>

					{/* Search Controls */}
					<PlayerSearchControls />
				</div>

				<Separator className="my-4 sm:my-6" />

				{/* Table Section */}
				<div className="space-y-4">
					<DataTableArrow
						columns={columns}
						data={data}
						total={total}
						isLoading={isLoading}
						onSort={onSort}
					/>
				</div>
			</div>
		</Card>
	)
}
